import React from "react";
import Layout from "../components/layout";
import { useStaticQuery, graphql } from "gatsby";
import { Card, Col, Row, Carousel } from "react-bootstrap";

const Type = ({ type }) => {
  return (
    <div className={`project-type ${type}`}>
      <span className="">{type + " Project"}</span>
    </div>
  );
};

const Link = ({ link }) => {
  var customClass = "";
  var image = "";
  switch (link.image) {
    case "github":
      image = "../images/icons/GitHub_Logo.png";
      break;
    default:
      image = link.image;
      customClass = "custom-link-image";
      break;
  }

  return (
    <div>
      <a href={link.url}>
        <img
          src={image}
          alt="Project Link"
          className={`link-image float-md-right ${customClass}`}
        />
      </a>
    </div>
  );
};

const Skills = ({ items }) => {
  const skillItems = items.map(item => {
    return <span className="project-skills">{item}</span>;
  });

  return <span>{skillItems}</span>;
};

const Section = ({ title, description }) => {
  return (
    <Col>
      {title && <h6>{title}</h6>}
      {description}
    </Col>
  );
};

const Demos = ({ links }) => {
  const linkItems = links.map((link, key) => {
    return (
      <li key={key}>
        <Row>
          <Col>
            <a href={link.url}>{link.title}</a>
            <div>{link.description}</div>
          </Col>
        </Row>
      </li>
    );
  });
  return (
    <Col>
      <h6>Demos</h6>
      <ul>{linkItems}</ul>
    </Col>
  );
};

const Photos = ({ photos }) => {
  const photoItems = photos.map(photo => {
    return (
      <Carousel.Item>
        <img src={photo.url} className="d-block image" alt={photo.caption} />
        <Carousel.Caption>{photo.caption}</Carousel.Caption>
      </Carousel.Item>
    );
  });

  return (
    <Col>
      <h6>Photos</h6>
      <Row>
        <Col></Col>
        <Col>
          <Carousel className="photos">{photoItems}</Carousel>
        </Col>
        <Col></Col>
      </Row>
    </Col>
  );
};

const Project = ({ project }) => {
  return (
    <Card>
      <Card.Header>
        <Col>
          <Row>
            <Col md={8} xs={12}>
              <div className="work-name">{project.title}</div>
              <Skills items={project.skills} />
            </Col>
            <Col md={4} xs={12}>
              <div className="float-md-right">
                <Type type={project.type} />
                {project.link && <Link link={project.link} />}
              </div>
            </Col>
          </Row>
        </Col>
      </Card.Header>
      <Card.Body>
        {project.description && (
          <Section title="Description" description={project.description} />
        )}
        {project.links && (
          <>
            <hr />
            <Demos links={project.links} />
          </>
        )}

        {project.images && (
          <>
            <hr />
            <Photos photos={project.images} />
          </>
        )}
      </Card.Body>
    </Card>
  );
};

const ProjectsPage = () => {
  const data = useStaticQuery(graphql`
    {
      dataYaml {
        projects {
          items {
            title
            type
            link {
              url
              image
            }
            description
            skills
            links {
              title
              description
              url
            }
            images {
              url
              caption
            }
          }
        }
      }
    }
  `).dataYaml.projects.items;

  const projectItems = data.map(project => <Project project={project} />);

  return <Layout title="Projects">{projectItems}</Layout>;
};

export default ProjectsPage;
